import { useState } from "react";
import Grid from "@mui/material/Grid";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import ContentBox from "../../../actprep-ui/components/ContentBox";
import ProgramNavTree from "../../../components/ProgramNavTree";
import SingleProgramWeekNavTree from "../../../components/SingleProgramWeekNavTree";
import ProgramDayScheduleBuilder from "../../../components/ProgramDayScheduleBuilder";
import layout from "../../../actprep-ui/constants/layout";
import { useTheme } from "@mui/material/styles";

export default function CurriculumBuilder() {
  const [programDay, setProgramDay] = useState(null);
  const handleProgramDayClick = (event, programDay) => {
    event.stopPropagation();
    setProgramDay(programDay);
  };
  const { palette } = useTheme();
  const [tab, setTab] = useState("program-editor");

  return (
    <ContentBox
      sx={{
        paddingTop: `${layout.navBarHeight + 1}rem`,
        minHeight: "90vh",
        width: "100%",
        marginBottom: "1rem",
      }}
    >
      <Typography variant="h5" fontWeight={"bold"}>
        Curriculum Builder
      </Typography>
      <Grid container spacing={1}>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
          sx={{
            maxHeight: {
              md: "90vh",
            },
            overflowY: "auto",
            overflowX: "hidden",
            scrollbarWidth: "thin",
            scrollbarColor: `${palette.background.secondary} ${palette.background.scrollbar}`,
            paddingRight: {
              md: "1rem",
            },
            borderRight: {
              md: "1px solid " + palette.divider,
            },
          }}
        >
          <Grid container direction={"column"} spacing={1} sx={{}}>
            <Grid size={12}>
              <Tabs
                value={tab}
                centered
                onChange={(event, newTab) => setTab(newTab)}
              >
                <Tab label="Program" value={"program-editor"} />
                <Tab label="Program Week" value={"program-week-editor"} />
              </Tabs>
            </Grid>
            <Grid size={12}>
              {tab === "program-editor" && (
                <ProgramNavTree onProgramDaySelect={handleProgramDayClick} />
              )}
              {tab === "program-week-editor" && (
                <SingleProgramWeekNavTree
                  onProgramDaySelect={handleProgramDayClick}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
          sx={{
            maxHeight: {
              md: "90vh",
            },
            overflowY: "auto",
            overflowX: "hidden",
            scrollbarWidth: "thin",
            scrollbarColor: `${palette.background.secondary} ${palette.background.scrollbar}`,
          }}
        >
          <ProgramDayScheduleBuilder programDay={programDay} />
        </Grid>
      </Grid>
    </ContentBox>
  );
}
